import { Button, Field, Input } from '@fluentui/react-components';
import { useMemo, useState } from 'react';
import type { Setting } from '../../../models/Setting';

export const TaxSettings = ({ settings, onSave }: { settings: Setting[]; onSave: (key: string, value: string, metadata?: Partial<Setting>) => void }) => {
  const currentTax = useMemo(() => settings.find((item) => item.cr_crm_key === 'defaultTaxRate')?.cr_crm_value ?? '0.19', [settings]);
  const [taxRate, setTaxRate] = useState(currentTax);

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <Field label="Default tax rate"><Input type="number" value={taxRate} onChange={(_, data) => setTaxRate(data.value)} /></Field>
      <Button appearance="primary" onClick={() => onSave('defaultTaxRate', taxRate, { cr_crm_label: 'Default tax rate', cr_crm_category: 'Offers', cr_crm_settingtype: 'number' })}>Save tax setting</Button>
    </div>
  );
};
